import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { AppProvider, useApp } from '../../context/AppContext';
import { Toaster } from '../ui/sonner';

const LoadingScreen = () => (
  <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
    <div className="flex flex-col items-center gap-4">
      <div className="w-12 h-12 rounded-md flex items-center justify-center bg-gradient-to-br from-[#D4AF37] to-[#8B7220] animate-pulse">
        <span className="font-display font-bold text-zinc-950 text-lg">C</span>
      </div>
      <div className="text-[11px] text-zinc-500 tracking-widest uppercase">Inicializando sistema</div>
    </div>
  </div>
);

const ShellInner = () => {
  const { loading } = useApp();
  if (loading) return <LoadingScreen />;
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50">
      <Sidebar />
      <main className="pl-64 min-h-screen">
        <Outlet />
      </main>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
};

export default function AppShell() {
  return (
    <AppProvider>
      <ShellInner />
    </AppProvider>
  );
}
